import { ACTION_TYPES as PROJECTS_ACTION_TYPES } from "../redux/projects/constants";

const data = {
  getWorkspaces: [],
  pendingWorkspaceInvites: [],
  currentWorkspace: {},
  workspaceProjects: [],
  search: {
    results: {},
    isLoading: false,
    page: 1
  },
  workspaceFilter: null,
  workspaceCustomFields: [],
  workspaceTags: [],
  workspaceDashboard: {},
  charts: {
    labels: ["Critical", "High", "Medium", "Low"],
    datasets: [{
      label: "No Due Date",
      data: [0, 0, 0, 0],
      backgroundColor: "#FF974E",
    }, {
      label: "On Track",
      data: [0, 0, 0, 0],
      backgroundColor: "#0074cc",
    },
    {
      label: "Completed",
      data: [0, 0, 0, 0],
      backgroundColor: "#78b373",
    },
    {
      label: "Overdue",
      data: [0, 0, 0, 0],
      backgroundColor: "#FF4E4E",
    }]
  },
  workspacePortfolios: [],
  selectedPortfolio: {}
};

const workspaceReducer = (state = data, action) => {
  switch (action.type) {
    case "workspace-success":
      sessionStorage.setItem("workspaceId", action.payload?._id);
      localStorage.setItem("workspaceId", action.payload?._id);
      sessionStorage.setItem("organization", action.payload?.organization);
      localStorage.setItem("organization", action.payload?.organization);

      return {
        ...state,
        success: action.payload,
        // currentWorkspace: action.payload
      };

    case "workspace-error":
      return {
        ...state,
        error: action.payload,
      };

    case PROJECTS_ACTION_TYPES.ADD_PROJECT_REQUEST_SUCCESS: //'add-project':
      return {
        ...state,
        workspaceProjects: [...state.workspaceProjects, action.payload],
      };

    case "get-workspaces":
      const workspaces = action.payload || [];
      if (!sessionStorage.getItem("workspaceId")) {
        sessionStorage.setItem("workspaceId", localStorage.getItem("workspaceId"));
      }
      if (!sessionStorage.getItem("organization")) {
        sessionStorage.setItem("organization", localStorage.getItem("organization"));
      }
      const id = sessionStorage.getItem("workspaceId") || localStorage.getItem("workspaceId");
      const workspace = workspaces.find(workspace => workspace._id === id);
      return {
        ...state,
        getWorkspaces: workspaces,
        // currentWorkspace: workspace || workspaces?.[0] || {}
      };
    case "get-workspace-invites":
      return {
        ...state,
        pendingWorkspaceInvites: action.payload
      };
    case 'toggle-pin-item': {
      const { data, isPinned } = action.payload;

      if (data.entityType === 'project') {
        return {
          ...state,
          workspaceProjects: state.workspaceProjects.map(project =>
            project._id === data.entityId
              ? { ...project, pinned: isPinned }
              : project
          )
        };
      }

      return state;
    }

    case "set-workspace-fields":
      return {
        ...state,
        workspaceCustomFields: action.payload,
      }
    case "add-workspace-field":
      return {
        ...state,
        workspaceCustomFields: [...state.workspaceCustomFields, action.payload],
      }
    case "delete-workspace-field":
      const x = state?.workspaceCustomFields?.filter(field => field?._id !== action.payload);

      return {
        ...state,
        workspaceCustomFields: x,
      }

    case "set-current-workspace":
      return {
        ...state,
        currentWorkspace: action.payload,
      };

    case "workspace-delete":
      const newState = state.getWorkspaces.filter(workspace => workspace._id !== action.payload)
      return {
        ...state,
        getWorkspaces: newState,
        currentWorkspace: newState[0] || {}
      };
    case "workspace-remove-invite":
      const newInvites = state.pendingWorkspaceInvites.filter(invite => invite._id !== action.payload)
      return {
        ...state,
        pendingWorkspaceInvites: newInvites,
      };

    case "workspace-projects":
      return {
        ...state,
        workspaceProjects: action.payload,
      };

    case "search-workspace-popover":
    case "search-workspace-page":
      return {
        ...state,
        search: {
          ...state.search,
          results: action.payload || {},
        },
      }

    case "delete-search-task": {
      const deletedTaskId = action.payload;

      return {
        ...state,
        search: {
          ...state.search,
          results: {
            ...state.search.results,
            tasks: state.search.results?.tasks?.filter(
              (task) => task._id !== deletedTaskId
            ),
          },
        },
      };
    }

    case "search-workspace-loading":
      return {
        ...state,
        search: {
          ...state.search,
          isLoading: action.payload,
        },
      }
    case "edit-search-task": {
      const updatedTask = action.payload.updatedTask;

      return {
        ...state,
        search: {
          ...state.search,
          results: {
            ...state.search.results,
            tasks: state.search?.results?.tasks?.map((task) =>
              task._id === updatedTask._id ? { ...task, ...updatedTask } : task
            ),
          },
        },
      };
    }

    case "workspaceFilter":
      return {
        ...state,
        workspaceFilter: action.payload
      }

    case 'delete-project':
      return {
        ...state,
        workspaceProjects: state.workspaceProjects.filter(
          (proj) => proj._id !== action.payload
        ),
      };

    case 'restore-project':
      return {
        ...state,
        workspaceProjects: [action.payload, ...state.workspaceProjects],
      };

    case 'update-workspace-project':
      return {
        ...state,
        workspaceProjects: state.workspaceProjects.map(project =>
          project._id === action.payload?._id ? { ...project, ...action.payload } : project
        ),
      };

    case "remove-workspace-user":
      const updatedMembers = state.currentWorkspace?.members?.filter(member => member._id !== action.payload);
      return {
        ...state,
        currentWorkspace: { ...state.currentWorkspace, members: updatedMembers }
      }

    case "workspaceDashboard":
      return {
        ...state,
        workspaceDashboard: action.payload
      }

    case "workspaceCharts":
      return {
        ...state,
        charts: action.payload
      }

    case "getWorkspaceTags":
      return {
        ...state,
        workspaceTags: action.payload
      }
    case 'add-workspace-tag':
      return {
        ...state,
        workspaceTags: [...(state.workspaceTags || []), action.payload]
      }
    case 'remove-workspace-tag':
      return {
        ...state,
        workspaceTags: (state.workspaceTags || []).filter(({ _id }) => _id !== action.payload)
      }

    case 'update-workspace-tag':
      return {
        ...state,
        workspaceTags: (state.workspaceTags || []).map((t) =>
          t._id === action.payload?._id ? { ...t, ...action.payload } : t
        ),
      }

    case "set-portfolios":
      return {
        ...state,
        workspacePortfolios: action.payload
      }

    case "set-portfolio":
      return {
        ...state,
        selectedPortfolio: action.payload
      }

    case 'update-pin-portfolio': {
      const { isPinned } = action.payload;

      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          pinned: isPinned
        }
      };
    }

    case "update-portfolio-data":
      const { name, access } = action.payload;
      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          name: name,
          access: access,
        },
      };

    case "add-portfolios":
      return {
        ...state,
        workspacePortfolios: [...state.workspacePortfolios, action.payload]
      }

    case 'delete-portfolio':
      return {
        ...state,
        workspacePortfolios: state.workspacePortfolios?.filter(portfolio => portfolio?._id !== action?.payload)
      }

    case 'remove-project-portfolio':
      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          projects: state.selectedPortfolio?.projects?.filter(pro => pro?._id !== action?.payload?.projects?.[0])
        }
      }

    case 'add-project-portfolio': {
      const projectToAdd = action?.payload?.projects
        ?.map(p => state?.workspaceProjects?.find(pta => pta?._id == p))
        .filter(Boolean);

      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          projects: [...(state.selectedPortfolio?.projects || []), ...projectToAdd]
        }
      }
    }

    case 'add-portfolio-members':
      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          participants: [...(state.selectedPortfolio?.participants || []), ...action.payload]
        }
      }

    case 'remove-portfolio-member':
      return {
        ...state,
        selectedPortfolio: {
          ...state.selectedPortfolio,
          participants: (state.selectedPortfolio?.participants || []).filter(p => p._id !== action.payload)
        }
      }

    default:
      return state;
  }
};
export default workspaceReducer;
